const url = 'https://staging.qidpro.xyz';
import { AppName } from "@qid/common";


export const environment = {
  appName: AppName.WebGateway,
  production: false,
  url: url + '/',
  imageBaseUrl: url + '/file/images/',
  collectUrl: 'https://devcollect.oneqid.com/rt/',
  gatewayUrl: 'https://devcollect.oneqid.com/',
  waPhone: "15550876181"
};
